//libs
import { ReactNode, useContext, useMemo, useState, useEffect } from 'react';
import Pagination from 'rc-pagination';

//component
import StoreItem from './store-item';

//types
import { Store } from '../../../../types/';
import { IStoresListProps } from '../types/IStoresListProps';
import { StoresContext } from '../../../../App';

const PaginationItem = (page: number, type: string, element: ReactNode) => {
    switch (type) {
        case 'page': {
            return <div className="pagination-list__page">{page}</div>;
        }
        case 'prev': {
            return (
                <div className="pagination__prev">
                    <svg width="10" height="12" viewBox="0 0 10 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M4.22333 11.3187L9.05151 5.6284L4.22333 -0.0035553L0.0515137 -0.0035553L4.9381 5.6284L0.0515137 11.3187H4.22333Z" fill="#050505"/>
                    </svg>
                </div>
            );
        }
        case 'next': {
            return (
                <div className="pagination__next">
                    <svg width="10" height="12" viewBox="0 0 10 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M4.22333 11.3187L9.05151 5.6284L4.22333 -0.0035553L0.0515137 -0.0035553L4.9381 5.6284L0.0515137 11.3187H4.22333Z" fill="#050505"/>
                    </svg>
                </div>
            );
        }
        case 'jump-prev':
        case 'jump-next': {
            return <div className="ui-pagination-nav__item">...</div>;
        }
    }
    return element;
};

export default function StoresList({
    country,
    city,
    isSkipCityCheck = false,
}: IStoresListProps){
    const { 
        stores
    } = useContext(StoresContext);
    const pageSize = 12;
    const [page, setPage] = useState(1);

    const data = useMemo(() => {
        const storesSet = new Set<Store>();

        for (const s of stores) {
            if (
                (s.city === city || isSkipCityCheck) &&
                s.country === country
            ) {
                storesSet.add(s);
            }
        }

        const preparedStores = Array.from(storesSet);

        return {
            list: preparedStores,
        };
    }, [stores, country, city, isSkipCityCheck]);

    const storesList = data.list;

    useEffect(() => {
        setPage(1);
    }, [storesList]);

    const visibleStores = useMemo(() => {
        return storesList.slice((page - 1) * pageSize, page * pageSize);
    }, [storesList, page, pageSize]);

    return visibleStores.length ? (
        <>
            <div className="stores-block__list stores-list">
                {visibleStores.map( store => (
                    <StoreItem store={store} />
                ))}
            </div>
            <div>
                <div className="pagination">
                    <Pagination
                        className="pagination-list"
                        pageSize={pageSize}
                        current={page}
                        showLessItems
                        onChange={setPage}
                        total={stores.length}
                        itemRender={PaginationItem}
                        showTitle={false}
                    />
                </div>
            </div>
        </>
    ) : null;
}